import { InputTlsFailure } from '../../types';
import { HTKEventBase } from '../events/event-base';

export class FailedTlsConnection extends HTKEventBase {

    constructor(
        private failureEvent: InputTlsFailure
    ) {
        super();

        this.searchIndex = [this.upstreamHostname, failureEvent.remoteIpAddress]
            .filter((x): x is string => !!x)
            .join('\n');
    }

    readonly id = crypto.randomUUID();

    readonly upstreamHostname = this.failureEvent.tlsMetadata.sniHostname ??
        this.failureEvent.destination?.hostname ??
        this.failureEvent.hostname;
    readonly remoteIpAddress = this.failureEvent.remoteIpAddress;
    readonly remotePort = this.failureEvent.remotePort;
    readonly failureCause = this.failureEvent.failureCause;
    readonly tags = this.failureEvent.tags;
    readonly timingEvents = this.failureEvent.timingEvents;
    readonly tlsMetadata = this.failureEvent.tlsMetadata;

    isTlsFailure(): this is FailedTlsConnection {
        return true;
    }

}